import { map } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "../../../../../environments/environment";
import { ContaVinculada } from "../models/conta-vinculada";
import { Pagination } from "../models/pagination";
import { SearchResult } from "../models/search-result";
import { Observable } from "rxjs";
import { Oauth2TokenService } from "../../../../../services/oauth2-token.service";
import { HttpInterceptor } from "../../../../shared/interceptors/http-interceptor.service";
import { CobrancaAssinatura } from "../models/cobranca_assinatura";
import { HttpHeaders, HttpParams } from "@angular/common/http";

@Injectable()
export class ContaVinculadaService {
  private contaVinculadaUrl: string;
  private cobrancaStatusUrl: string;
  private cobrancaAssinaturaUrl: string;
  private cobrancaGridUrl: string;
  private organizacaoUrl: string;
  private bancoUrl: string;
  private cobrancaModalidadeUrl: string;
  private cobrancaModalidadeTipoUrl: string;
  contaVinculada: ContaVinculada[] = [];
  pagination: Pagination[] = [];

  constructor(
    private http: HttpInterceptor,
    private router: Router,
    private oauth2Token: Oauth2TokenService
  ) {
    this.contaVinculadaUrl =
      environment.api.base_url + "/api/v1/conta_vinculada";
    this.cobrancaAssinaturaUrl =
      environment.api.base_url + "/api/v1/cobranca_assinatura";
    this.cobrancaStatusUrl =
      environment.api.base_url + "/api/v1/cobranca_status";
    this.cobrancaGridUrl =
      environment.api.base_url + "/api/v1/conta_vinculada/grid";
    this.organizacaoUrl = environment.api.base_url + "/api/v1/organizacao";
    this.bancoUrl = environment.api.base_url + "/api/v1/banco";
    this.cobrancaModalidadeUrl =
      environment.api.base_url + "/api/v1/cobranca_modalidade";
    this.cobrancaModalidadeTipoUrl =
      environment.api.base_url + "/api/v1/cobranca_modalidade_tipo";
  }

  getHeaders() {
    return new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.oauth2Token.token}`,
    });
  }

  getSearchResult(params?: HttpParams): Promise<SearchResult> {
    return this.http
      .get(this.contaVinculadaUrl, {
        params: params,
        headers: this.getHeaders(),
      })
      .toPromise()
      .then((response) => {
        let result = new SearchResult();
        let responseJson = response;
        result.contasVinculadas = responseJson.data as ContaVinculada[];
        result.pagination = responseJson.meta.pagination as Pagination;
        return result;
      })
      .catch(this.handleError);
  }

  getSearchResultGrid(params?: HttpParams): Promise<SearchResult> {
    return this.http
      .get(this.cobrancaGridUrl, { params: params, headers: this.getHeaders() })
      .toPromise()
      .then((response) => {
        let result = new SearchResult();
        let responseJson = response;
        result.contasVinculadas = responseJson.data as ContaVinculada[];
        result.pagination = responseJson.meta.pagination as Pagination;
        return result;
      })
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error("An error occurred", error);
    return Promise.reject(error.message || error);
  }

  getCobrancaModalidade(params?) {
    let headers = this.getHeaders();
    let url = this.cobrancaModalidadeUrl;

    return this.http
      .get(url, { params: params, headers: headers })
      .pipe(map((res: any) => res));
  }

  getCobrancaAssinatura(params: HttpParams) {
    let headers = this.getHeaders();
    let url = this.cobrancaAssinaturaUrl;

    return this.http
      .get(url, { params: params, headers: headers })
      .pipe(map((res: any) => res.data));
  }

  getCobrancaModalidadeTipo(params?: HttpParams) {
    let headers = this.getHeaders();
    let url = this.cobrancaModalidadeTipoUrl;

    return this.http
      .get(url, { params: params, headers: headers })
      .pipe(map((res: any) => res));
  }

  getContaVinculada(
    id: string,
    onlyAddress?: boolean
  ): Promise<ContaVinculada> {
    let params = new HttpParams().set("id", id);

    if (onlyAddress) {
      params = params.set("include", "endereco");
    } else {
      params = params.set("include", "organizacao,endereco");
    }

    return this.getSearchResult(params).then((result) =>
      result.contasVinculadas.find((contaVinculada) => contaVinculada.id === id)
    );
  }

  getContaVinculadaToChange(id: string): Promise<any> {
    let params = new HttpParams()
      .set("id", id)
      .set("include", "endereco");

    return this.getSearchResult(params)
      .then((result) =>
        result.contasVinculadas.find(
          (contaVinculada) => contaVinculada.id === id
        )
      )
      .then((result) => {
        result.endereco = result.endereco["data"];
        return result;
      });
  }

  getCobrancaStatus(params?: HttpParams): Promise<any[]> {
    let headers = this.getHeaders();
    let url = this.cobrancaStatusUrl;

    return this.http
      .get(url, { params: params, headers: headers })
      .pipe(map((res: any) => res.data))
      .toPromise();
  }

  getBanco(params: HttpParams) {
    let headers = this.getHeaders();
    let url = this.bancoUrl;

    return this.http
      .get(url, { params: params, headers: headers })
      .pipe(map((res: any) => res));
  }

  getOrganizacao(params?: HttpParams): Observable<Array<any>> {
    let headers = this.getHeaders();
    let url = this.organizacaoUrl;

    return this.http
      .get(url, { params: params, headers: headers })
      .pipe(map((res: any) => res.data));
  }

  updateStatus(
    status: string,
    valor_pago: number,
    data_pagamento: string,
    contaVinculada: ContaVinculada
  ): Promise<void> {
    const url = `${this.contaVinculadaUrl}/${contaVinculada.id}`;
    return this.http
      .patch(
        url,
        {
          status: status,
          data_pagamento: data_pagamento,
          valor_pago: valor_pago,
        },
        { headers: this.getHeaders() }
      )
      .toPromise()
      .then((res) => {
        let responseJson = res;

        return responseJson;
      });
  }

  update(contaVinculada: ContaVinculada): Promise<void> {
    const url = `${this.contaVinculadaUrl}/${contaVinculada.id}`;
    return this.http
      .put(url, JSON.stringify(contaVinculada), { headers: this.getHeaders() })
      .toPromise()
      .then((res) => res);
  }

  create(contaVinculada: ContaVinculada): Promise<any> {
    return this.http
      .post(this.contaVinculadaUrl, JSON.stringify(contaVinculada), {
        headers: this.getHeaders(),
      })
      .toPromise()
      .then((res) => res);
  }

  createAssinatura(assinatura: CobrancaAssinatura): Promise<ContaVinculada> {
    return this.http
      .post(this.cobrancaAssinaturaUrl, JSON.stringify(assinatura), {
        headers: this.getHeaders(),
      })
      .toPromise()
      .then((res) => res.data);
  }

  delete(id: string): Promise<void> {
    const url = `${this.contaVinculadaUrl}/${id}`;
    return this.http
      .delete(url, { headers: this.getHeaders() })
      .toPromise()
      .then((res) => {
        let responseJson = res;
        this.router.navigate(["/pages/conta-vinculada/"]);
      });
  }
}
